import React from 'react';
import { Badge } from 'reactstrap';

import { Button } from '~components';
import { faEdit } from '~components/icon';
import { Column, Row } from '~components/table-view';
import { genericCellRender, linkCellRender } from '~components/table-view/columnRenderers';

const STATUS_COLORS: Record<string, string> = {
  draft: 'warning',
  published: 'success',
};

export const getTemplateColumns = (
  onOpen: (row: Row) => void,
  onFill: (row: Row) => void,
  canEdit: boolean,
  canFill: boolean,
): Column[] => [
  {
    id: 'title',
    header: 'Title',
    type: 'text',
    // The title links into the CREATE-gated builder, so only editors get the clickable edit link.
    // View-only users (e.g. care workers with Fill access) see the title as plain text — there is no
    // view-only template-detail route, so a link would just bounce them to /access-denied.
    renderReadOnly: canEdit ? linkCellRender(onOpen, faEdit) : genericCellRender((value) => <span>{value}</span>),
  },
  {
    id: 'status',
    header: 'Status',
    type: 'text',
    renderReadOnly: genericCellRender((value) => (
      <Badge color={STATUS_COLORS[value] ?? 'secondary'} pill className="text-capitalize">
        {value}
      </Badge>
    )),
  },
  {
    id: 'description',
    header: 'Description',
    type: 'text',
    deriveValue: (row) => row.description ?? '',
  },
  {
    id: 'actions',
    header: '',
    type: 'text',
    renderReadOnly: genericCellRender((_v, row) => {
      if (row.status !== 'published') return null;
      return (
        <Button
          color="info"
          size="sm"
          disabled={!canFill}
          title={canFill ? undefined : 'You do not have permission to fill forms'}
          onClick={() => onFill(row)}
          dataCy={`forms-fill-btn-${row.id}`}
        >
          Fill
        </Button>
      );
    }),
  },
];
